module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afoot56-fef9c8d6d29bd8dcc3b96ad4624aa18f.jpg";